













import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { TypedForm } from '@/shared/forms/typed-form'

@Component
export default class RespondecoTypedForm extends Vue {
  @Prop({
    default: () => false,
    type: Boolean,
  })
  public readonly emitOnEnter!: boolean

  @Prop({
    required: true,
    type: Object,
  })
  public readonly form!: TypedForm<any, any>

  public provide() {
    return {
      form: this.form.group(),
    }
  }
}
